import React from 'react'
import GatsbyConfig from '../../../gatsby-config.js'

const { siteMetadata: config } = GatsbyConfig

export default class RoomRibbon extends React.Component {
  render() {
    const { room } = this.props

    return room.recommended ? (
      <div className="ribbon recommended">
        <span>Recommended</span>
      </div>
    ) : room.popular ? (
      <div className="ribbon popular">
        <span>Popular</span>
      </div>
    ) : room.worthUpgrade ? (
      <div className="ribbon worth-upgrade">
        <span>Worth Upgrade</span>
      </div>
    ) : (
      <div />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/partials/room-ribbon.js